import coverImg from "assets/images/v116/cover.webp"

export const v116Config = {
  cover: {
    en: coverImg,
  },
}
